// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url: '',
  //#region mingle
  appIdentifier: '60ec72a9f780737a4ce234d2',
  server: 'https://dev-mingle.totvs.com.br',
  //#endregion
  allowedRoutesByOrigin: {
    'http://dev.bdd.wssim.com.br': [
      'login',
      'carga',
      'sales-order/details/',
      'sales-order/maintenance/',
      'sales-budget/details/',
      'sales-budget/maintenance/'
    ]
  },
  pgvVersion: '1.13.20'
};
